const NoVisitPlan = () => {
  return (
    <svg
      width="118"
      height="82"
      viewBox="0 0 118 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M83.4712 7.12201H31.0401C30.6463 7.12201 30.327 7.44126 30.327 7.83508V80.2871C30.327 80.6809 30.6463 81.0002 31.0401 81.0002H83.4712C83.865 81.0002 84.1843 80.6809 84.1843 80.2871V7.83508C84.1843 7.44126 83.865 7.12201 83.4712 7.12201Z"
        fill="#0085FF"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M80.2683 10.0791V75.3694L32.5473 76.495C31.6959 76.5165 30.9948 75.8821 30.9948 75.0951V73.8693H30.327V61.0244C32.2325 43.8439 32.4925 16.0794 32.5259 11.0473C32.5283 10.6085 32.9146 10.2508 33.3892 10.2508L80.2683 10.0791Z"
        fill="#12183E"
      />
      <path
        d="M81.5274 10.6224V73.969C81.5274 74.2576 81.2746 74.4913 80.9622 74.4913H34.1618C33.8494 74.4913 33.5966 74.2576 33.5966 73.969V10.6224C33.5966 10.3338 33.8494 10.1001 34.1618 10.1001H80.9622C81.2746 10.1001 81.5274 10.3338 81.5274 10.6224Z"
        fill="#F6F5F5"
        stroke="#12183E"
        strokeWidth="0.143092"
        strokeLinejoin="round"
      />
      <path
        d="M76.1973 72.1974C63.6219 73.3302 49.0361 73.7428 33.5966 73.8502V41.9384L36.7398 10.2937L77.788 10.1029H77.7928C78.1028 10.1029 78.3556 10.3366 78.3556 10.6252C78.3818 35.628 79.2261 65.5389 76.1973 72.1974Z"
        fill="#E1E1E1"
      />
      <path
        d="M77.2227 70.1678C56.639 73.2156 42.7663 73.4231 31.5193 72.6886C31.2045 72.6671 30.9684 72.4119 30.997 72.121C32.4184 57.6949 33.0026 34.1683 33.5846 10.6131C33.5917 10.3293 33.8421 10.1027 34.1498 10.1027L58.8259 10.1528L80.9669 10.0979C81.277 10.0979 81.5297 10.3269 81.5345 10.6154C81.8636 35.3607 81.9948 59.5694 77.2227 70.1654V70.1678Z"
        fill="white"
        stroke="#12183E"
        strokeWidth="0.143092"
        strokeLinejoin="round"
      />
      <path
        d="M75.5163 17.952H48.6652C48.3623 17.952 48.1167 18.1976 48.1167 18.5005V18.9918C48.1167 19.2948 48.3623 19.5403 48.6652 19.5403H75.5163C75.8193 19.5403 76.0649 19.2948 76.0649 18.9918V18.5005C76.0649 18.1976 75.8193 17.952 75.5163 17.952Z"
        fill="#E1E1E1"
      />
      <path
        d="M60.2485 21.1977H48.6628C48.3612 21.1977 48.1167 21.4422 48.1167 21.7439V22.2304C48.1167 22.532 48.3612 22.7765 48.6628 22.7765H60.2485C60.5501 22.7765 60.7946 22.532 60.7946 22.2304V21.7439C60.7946 21.4422 60.5501 21.1977 60.2485 21.1977Z"
        fill="#E1E1E1"
      />
      <path
        d="M44.6086 17.275H39.474C39.1078 17.275 38.811 17.5718 38.811 17.938V22.5884C38.811 22.9546 39.1078 23.2514 39.474 23.2514H44.6086C44.9747 23.2514 45.2716 22.9546 45.2716 22.5884V17.938C45.2716 17.5718 44.9747 17.275 44.6086 17.275Z"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M41.7374 21.5342L40.3613 20.5516C40.2373 20.4634 40.2159 20.2989 40.3112 20.1844L40.4543 20.0127C40.5497 19.8982 40.7262 19.8767 40.8502 19.965L41.8399 20.6733L43.3806 19.0325C43.4831 18.9228 43.662 18.9109 43.7788 19.0063L43.9553 19.147C44.0722 19.2424 44.0865 19.4069 43.9839 19.5166L42.1237 21.4961C42.026 21.601 41.8566 21.6153 41.7374 21.5318V21.5342Z"
        fill="#0085FF"
      />
      <path
        d="M44.6086 27.3603H39.474C39.1078 27.3603 38.811 27.6571 38.811 28.0233V32.6738C38.811 33.0399 39.1078 33.3367 39.474 33.3367H44.6086C44.9747 33.3367 45.2716 33.0399 45.2716 32.6738V28.0233C45.2716 27.6571 44.9747 27.3603 44.6086 27.3603Z"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M41.7374 31.6217L40.3613 30.6392C40.2373 30.5509 40.2159 30.3864 40.3112 30.2719L40.4543 30.1002C40.5497 29.9857 40.7262 29.9643 40.8502 30.0525L41.8399 30.7608L43.3806 29.12C43.4831 29.0103 43.662 28.9984 43.7788 29.0938L43.9553 29.2345C44.0722 29.3299 44.0865 29.4944 43.9839 29.6041L42.1237 31.5836C42.026 31.6885 41.8566 31.7028 41.7374 31.6194V31.6217Z"
        fill="#0085FF"
      />
      <path
        d="M44.6086 37.448H39.474C39.1078 37.448 38.811 37.7449 38.811 38.111V42.7615C38.811 43.1277 39.1078 43.4245 39.474 43.4245H44.6086C44.9747 43.4245 45.2716 43.1277 45.2716 42.7615V38.111C45.2716 37.7449 44.9747 37.448 44.6086 37.448Z"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M41.7374 41.7073L40.3613 40.7247C40.2373 40.6365 40.2159 40.4719 40.3112 40.3574L40.4543 40.1857C40.5497 40.0713 40.7262 40.0498 40.8502 40.138L41.8399 40.8463L43.3806 39.2056C43.4831 39.0959 43.662 39.0839 43.7788 39.1793L43.9553 39.32C44.0722 39.4154 44.0865 39.58 43.9839 39.6897L42.1237 41.6691C42.026 41.7741 41.8566 41.7884 41.7374 41.7049V41.7073Z"
        fill="#0085FF"
      />
      <path
        d="M44.6082 47.5338H39.4736C39.1074 47.5338 38.8106 47.8306 38.8106 48.1968V52.8473C38.8106 53.2134 39.1074 53.5103 39.4736 53.5103H44.6082C44.9744 53.5103 45.2712 53.2134 45.2712 52.8473V48.1968C45.2712 47.8306 44.9744 47.5338 44.6082 47.5338Z"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M44.6082 57.6216H39.4736C39.1074 57.6216 38.8106 57.9185 38.8106 58.2846V62.9351C38.8106 63.3013 39.1074 63.5981 39.4736 63.5981H44.6082C44.9744 63.5981 45.2712 63.3013 45.2712 62.9351V58.2846C45.2712 57.9185 44.9744 57.6216 44.6082 57.6216Z"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M75.516 27.7895H48.6649C48.3619 27.7895 48.1163 28.0351 48.1163 28.338V28.8293C48.1163 29.1323 48.3619 29.3778 48.6649 29.3778H75.516C75.8189 29.3778 76.0645 29.1323 76.0645 28.8293V28.338C76.0645 28.0351 75.8189 27.7895 75.516 27.7895Z"
        fill="#E1E1E1"
      />
      <path
        d="M60.2481 31.0352H48.6625C48.3608 31.0352 48.1163 31.2797 48.1163 31.5814V32.0679C48.1163 32.3695 48.3608 32.614 48.6625 32.614H60.2481C60.5497 32.614 60.7942 32.3695 60.7942 32.0679V31.5814C60.7942 31.2797 60.5497 31.0352 60.2481 31.0352Z"
        fill="#E1E1E1"
      />
      <path
        d="M75.516 38.3281H48.6649C48.3619 38.3281 48.1163 38.5737 48.1163 38.8766V39.3679C48.1163 39.6709 48.3619 39.9164 48.6649 39.9164H75.516C75.8189 39.9164 76.0645 39.6709 76.0645 39.3679V38.8766C76.0645 38.5737 75.8189 38.3281 75.516 38.3281Z"
        fill="#E1E1E1"
      />
      <path
        d="M60.2481 41.5738H48.6625C48.3608 41.5738 48.1163 41.8183 48.1163 42.12V42.6065C48.1163 42.9081 48.3608 43.1526 48.6625 43.1526H60.2481C60.5497 43.1526 60.7942 42.9081 60.7942 42.6065V42.12C60.7942 41.8183 60.5497 41.5738 60.2481 41.5738Z"
        fill="#E1E1E1"
      />
      <path
        d="M75.516 48.0729H48.6649C48.3619 48.0729 48.1163 48.3185 48.1163 48.6214V49.1127C48.1163 49.4156 48.3619 49.6612 48.6649 49.6612H75.516C75.8189 49.6612 76.0645 49.4156 76.0645 49.1127V48.6214C76.0645 48.3185 75.8189 48.0729 75.516 48.0729Z"
        fill="#E1E1E1"
      />
      <path
        d="M60.2481 51.3186H48.6625C48.3608 51.3186 48.1163 51.5631 48.1163 51.8647V52.3512C48.1163 52.6529 48.3608 52.8974 48.6625 52.8974H60.2481C60.5497 52.8974 60.7942 52.6529 60.7942 52.3512V51.8647C60.7942 51.5631 60.5497 51.3186 60.2481 51.3186Z"
        fill="#E1E1E1"
      />
      <path
        d="M75.516 59.2195H48.6649C48.3619 59.2195 48.1163 59.4651 48.1163 59.7681V60.2593C48.1163 60.5623 48.3619 60.8079 48.6649 60.8079H75.516C75.8189 60.8079 76.0645 60.5623 76.0645 60.2593V59.7681C76.0645 59.4651 75.8189 59.2195 75.516 59.2195Z"
        fill="#E1E1E1"
      />
      <path
        d="M60.2481 62.4652H48.6625C48.3608 62.4652 48.1163 62.7098 48.1163 63.0114V63.4979C48.1163 63.7995 48.3608 64.044 48.6625 64.044H60.2481C60.5497 64.044 60.7942 63.7995 60.7942 63.4979V63.0114C60.7942 62.7098 60.5497 62.4652 60.2481 62.4652Z"
        fill="#E1E1E1"
      />
      <path
        d="M0.430237 80.9907H117.57"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M40.0167 10.115C40.0167 10.115 39.0532 11.3933 39.1748 13.0961C39.2034 13.5063 39.5468 13.8258 39.957 13.8235L73.8363 13.7066C74.4039 13.0317 74.1798 11.5388 74.0247 10.1126H40.0167V10.115Z"
        fill="#12183E"
      />
      <path
        d="M58.2059 5.50974C58.2059 6.03441 57.7813 6.4613 57.2543 6.4613C56.7272 6.4613 56.3027 6.03679 56.3027 5.50974C56.3027 5.45489 56.3075 5.40004 56.317 5.34518C56.3934 5.79354 56.7845 6.13219 57.2543 6.13219C57.7241 6.13219 58.1128 5.79354 58.1915 5.34518C58.2011 5.39765 58.2059 5.4525 58.2059 5.50974Z"
        fill="#12183E"
      />
      <path
        d="M70.9652 7.835H64.092C64.092 4.05977 61.0323 1 57.257 1C53.4818 1 50.422 4.05977 50.422 7.835H43.5489C41.7864 7.835 40.3579 9.26354 40.3579 11.0259V12.092C40.3579 12.3018 40.5272 12.4712 40.7371 12.4712H73.7817C73.9916 12.4712 74.1609 12.3018 74.1609 12.092V11.0259C74.1609 9.26354 72.7324 7.835 70.97 7.835H70.9652ZM56.3198 5.34521C56.3961 4.89924 56.7872 4.55821 57.257 4.55821C57.7268 4.55821 58.1156 4.89686 58.1943 5.34521C58.2038 5.39768 58.2086 5.45253 58.2086 5.50977C58.2086 6.03444 57.7841 6.46133 57.257 6.46133C56.73 6.46133 56.3055 6.03682 56.3055 5.50977C56.3055 5.45492 56.3102 5.40006 56.3198 5.34521Z"
        fill="white"
      />
      <path
        d="M74.1558 11.5265V12.0917C74.1558 12.3016 73.9864 12.4709 73.7766 12.4709H40.7344C40.5245 12.4709 40.3552 12.3016 40.3552 12.0917V11.5265H74.1581H74.1558Z"
        fill="#BCBCBC"
      />
      <path
        d="M70.9652 7.835H64.092C64.092 4.05977 61.0323 1 57.257 1C53.4818 1 50.422 4.05977 50.422 7.835H43.5489C41.7864 7.835 40.3579 9.26354 40.3579 11.0259V12.092C40.3579 12.3018 40.5272 12.4712 40.7371 12.4712H73.7817C73.9916 12.4712 74.1609 12.3018 74.1609 12.092V11.0259C74.1609 9.26354 72.7324 7.835 70.97 7.835H70.9652ZM56.3198 5.34521C56.3961 4.89924 56.7872 4.55821 57.257 4.55821C57.7268 4.55821 58.1156 4.89686 58.1943 5.34521C58.2038 5.39768 58.2086 5.45253 58.2086 5.50977C58.2086 6.03444 57.7841 6.46133 57.257 6.46133C56.73 6.46133 56.3055 6.03682 56.3055 5.50977C56.3055 5.45492 56.3102 5.40006 56.3198 5.34521V5.34521Z"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M87.8117 25.7259H104.1"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
      <path
        d="M16.5685 38.3277H25.7026"
        stroke="#12183E"
        strokeWidth="0.138322"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoVisitPlan;
